import { fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query'

type CustomFetchArgs = FetchArgs & {
  meta?: {
    useToken?: boolean
  }
}

const rawBaseQuery = fetchBaseQuery({
  baseUrl: '' // import.meta.env.VITE_API_URL,
})

export const authenticatedBaseQuery: BaseQueryFn<
  string | CustomFetchArgs,
  unknown,
  FetchBaseQueryError
> = async (args, api, extraOptions) => {
  const state = api.getState() as any
  const token = sessionStorage.getItem('token')

  let modifiedArgs: CustomFetchArgs

  if (typeof args === 'string') {
    modifiedArgs = { url: args }
  } else {
    modifiedArgs = { ...args }
  }

  const useToken = modifiedArgs?.meta?.useToken !== false

  if (useToken && token) {
    modifiedArgs.headers = {
      ...modifiedArgs.headers,
      token: token // match the original Axios code
    }
  }

  return rawBaseQuery(modifiedArgs, api, extraOptions)
}
